import { network } from 'services/network';

export const getProgressMeasurementMethods = () => {
    const url = 'api/bo/getProgressMeasurementMethods';
    return network.get(url).then((response) => response.data);
};
